import { useQuery } from "@tanstack/react-query";
import { accessMatrixApi } from "../api/access-matrix";

const accessMatrixKeys = {
  all: ["access-matrix"] as const,
  matrix: (params?: Record<string, unknown>) => [...accessMatrixKeys.all, params] as const,
};

export function useAccessMatrix(params?: { first?: number; max?: number; search?: string }) {
  return useQuery({
    queryKey: accessMatrixKeys.matrix(params as Record<string, unknown>),
    queryFn: () => accessMatrixApi.getMatrix(params),
    refetchInterval: 60_000,
  });
}
